import { computed as T, ref as P, shallowRef as jt, watch as ut, getCurrentScope as Xt, onScopeDispose as Yt, shallowReadonly as q, unref as mt, defineComponent as qt, withDirectives as Ut, openBlock as Et, createElementBlock as Ct, createElementVNode as At, renderSlot as Rt, createVNode as Kt, Transition as Gt, withCtx as Jt, normalizeClass as Qt, normalizeStyle as St, createCommentVNode as Zt } from "vue";
import { _ as te } from "./chunks/_plugin-vue_export-helper.dad06003.js";
import './assets/FrPopover.css';const G = Math.min, z = Math.max, st = Math.round, rt = Math.floor, $ = (t) => ({
  x: t,
  y: t
}), ee = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, ne = {
  start: "end",
  end: "start"
};
function pt(t, e, n) {
  return z(t, G(e, n));
}
function nt(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function H(t) {
  return t.split("-")[0];
}
function ot(t) {
  return t.split("-")[1];
}
function _t(t) {
  return t === "x" ? "y" : "x";
}
function vt(t) {
  return t === "y" ? "height" : "width";
}
function J(t) {
  return ["top", "bottom"].includes(H(t)) ? "y" : "x";
}
function wt(t) {
  return _t(J(t));
}
function oe(t, e, n) {
  n === void 0 && (n = !1);
  const o = ot(t), i = wt(t), s = vt(i);
  let r = i === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return e.reference[s] > e.floating[s] && (r = lt(r)), [r, lt(r)];
}
function ie(t) {
  const e = lt(t);
  return [gt(t), e, gt(e)];
}
function gt(t) {
  return t.replace(/start|end/g, (e) => ne[e]);
}
function re(t, e, n) {
  const o = ["left", "right"], i = ["right", "left"], s = ["top", "bottom"], r = ["bottom", "top"];
  switch (t) {
    case "top":
    case "bottom":
      return n ? e ? i : o : e ? o : i;
    case "left":
    case "right":
      return e ? s : r;
    default:
      return [];
  }
}
function se(t, e, n, o) {
  const i = ot(t);
  let s = re(H(t), n === "start", o);
  return i && (s = s.map((r) => r + "-" + i), e && (s = s.concat(s.map(gt)))), s;
}
function lt(t) {
  return t.replace(/left|right|bottom|top/g, (e) => ee[e]);
}
function le(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function Nt(t) {
  return typeof t != "number" ? le(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function ct(t) {
  const {
    x: e,
    y: n,
    width: o,
    height: i
  } = t;
  return {
    width: o,
    height: i,
    top: n,
    left: e,
    right: e + o,
    bottom: n + i,
    x: e,
    y: n
  };
}
function Tt(t, e, n) {
  let {
    reference: o,
    floating: i
  } = t;
  const s = J(e), r = wt(e), l = vt(r), a = H(e), c = s === "y", f = o.x + o.width / 2 - i.width / 2, d = o.y + o.height / 2 - i.height / 2, p = o[l] / 2 - i[l] / 2;
  let u;
  switch (a) {
    case "top":
      u = {
        x: f,
        y: o.y - i.height
      };
      break;
    case "bottom":
      u = {
        x: f,
        y: o.y + o.height
      };
      break;
    case "right":
      u = {
        x: o.x + o.width,
        y: d
      };
      break;
    case "left":
      u = {
        x: o.x - i.width,
        y: d
      };
      break;
    default:
      u = {
        x: o.x,
        y: o.y
      };
  }
  switch (ot(e)) {
    case "start":
      u[r] -= p * (n && c ? -1 : 1);
      break;
    case "end":
      u[r] += p * (n && c ? -1 : 1);
      break;
  }
  return u;
}
const ce = async (t, e, n) => {
  const {
    placement: o = "bottom",
    strategy: i = "absolute",
    middleware: s = [],
    platform: r
  } = n, l = s.filter(Boolean), a = await (r.isRTL == null ? void 0 : r.isRTL(e));
  let c = await r.getElementRects({
    reference: t,
    floating: e,
    strategy: i
  }), {
    x: f,
    y: d
  } = Tt(c, o, a), p = o, u = {}, m = 0;
  for (let g = 0; g < l.length; g++) {
    const {
      name: v,
      fn: h
    } = l[g], {
      x: w,
      y,
      data: x,
      reset: b
    } = await h({
      x: f,
      y: d,
      initialPlacement: o,
      placement: p,
      strategy: i,
      middlewareData: u,
      rects: c,
      platform: r,
      elements: {
        reference: t,
        floating: e
      }
    });
    f = w ?? f, d = y ?? d, u = {
      ...u,
      [v]: {
        ...u[v],
        ...x
      }
    }, b && m <= 50 && (m++, typeof b == "object" && (b.placement && (p = b.placement), b.rects && (c = b.rects === !0 ? await r.getElementRects({
      reference: t,
      floating: e,
      strategy: i
    }) : b.rects), {
      x: f,
      y: d
    } = Tt(c, p, a)), g = -1);
  }
  return {
    x: f,
    y: d,
    placement: p,
    strategy: i,
    middlewareData: u
  };
};
async function Vt(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: o,
    y: i,
    platform: s,
    rects: r,
    elements: l,
    strategy: a
  } = t, {
    boundary: c = "clippingAncestors",
    rootBoundary: f = "viewport",
    elementContext: d = "floating",
    altBoundary: p = !1,
    padding: u = 0
  } = nt(e, t), m = Nt(u), v = l[p ? d === "floating" ? "reference" : "floating" : d], h = ct(await s.getClippingRect({
    element: (n = await (s.isElement == null ? void 0 : s.isElement(v))) == null || n ? v : v.contextElement || await (s.getDocumentElement == null ? void 0 : s.getDocumentElement(l.floating)),
    boundary: c,
    rootBoundary: f,
    strategy: a
  })), w = d === "floating" ? {
    x: o,
    y: i,
    width: r.floating.width,
    height: r.floating.height
  } : r.reference, y = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(l.floating)), x = await (s.isElement == null ? void 0 : s.isElement(y)) ? await (s.getScale == null ? void 0 : s.getScale(y)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, b = ct(s.convertOffsetParentRelativeRectToViewportRelativeRect ? await s.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: l,
    rect: w,
    offsetParent: y,
    strategy: a
  }) : w);
  return {
    top: (h.top - b.top + m.top) / x.y,
    bottom: (b.bottom - h.bottom + m.bottom) / x.y,
    left: (h.left - b.left + m.left) / x.x,
    right: (b.right - h.right + m.right) / x.x
  };
}
const ae = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: n,
      y: o,
      placement: i,
      rects: s,
      platform: r,
      elements: l,
      middlewareData: a
    } = e, {
      element: c,
      padding: f = 0
    } = nt(t, e) || {};
    if (c == null)
      return {};
    const d = Nt(f), p = {
      x: n,
      y: o
    }, u = wt(i), m = vt(u), g = await r.getDimensions(c), v = u === "y", h = v ? "top" : "left", w = v ? "bottom" : "right", y = v ? "clientHeight" : "clientWidth", x = s.reference[m] + s.reference[u] - p[u] - s.floating[m], b = p[u] - s.reference[u], E = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(c));
    let O = E ? E[y] : 0;
    (!O || !await (r.isElement == null ? void 0 : r.isElement(E))) && (O = l.floating[y] || s.floating[m]);
    const S = x / 2 - b / 2, A = O / 2 - g[m] / 2 - 1, F = G(d[h], A), Z = G(d[w], A), I = F, tt = O - g[m] - Z, C = O / 2 - g[m] / 2 + S, Y = pt(I, C, tt), N = !a.arrow && ot(i) != null && C !== Y && s.reference[m] / 2 - (C < I ? F : Z) - g[m] / 2 < 0, k = N ? C < I ? C - I : C - tt : 0;
    return {
      [u]: p[u] + k,
      data: {
        [u]: Y,
        centerOffset: C - Y - k,
        ...N && {
          alignmentOffset: k
        }
      },
      reset: N
    };
  }
}), fe = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var n, o;
      const {
        placement: i,
        middlewareData: s,
        rects: r,
        initialPlacement: l,
        platform: a,
        elements: c
      } = e, {
        mainAxis: f = !0,
        crossAxis: d = !0,
        fallbackPlacements: p,
        fallbackStrategy: u = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: g = !0,
        ...v
      } = nt(t, e);
      if ((n = s.arrow) != null && n.alignmentOffset)
        return {};
      const h = H(i), w = J(l), y = H(l) === l, x = await (a.isRTL == null ? void 0 : a.isRTL(c.floating)), b = p || (y || !g ? [lt(l)] : ie(l)), E = m !== "none";
      !p && E && b.push(...se(l, g, m, x));
      const O = [l, ...b], S = await Vt(e, v), A = [];
      let F = ((o = s.flip) == null ? void 0 : o.overflows) || [];
      if (f && A.push(S[h]), d) {
        const C = oe(i, r, x);
        A.push(S[C[0]], S[C[1]]);
      }
      if (F = [...F, {
        placement: i,
        overflows: A
      }], !A.every((C) => C <= 0)) {
        var Z, I;
        const C = (((Z = s.flip) == null ? void 0 : Z.index) || 0) + 1, Y = O[C];
        if (Y)
          return {
            data: {
              index: C,
              overflows: F
            },
            reset: {
              placement: Y
            }
          };
        let N = (I = F.filter((k) => k.overflows[0] <= 0).sort((k, M) => k.overflows[1] - M.overflows[1])[0]) == null ? void 0 : I.placement;
        if (!N)
          switch (u) {
            case "bestFit": {
              var tt;
              const k = (tt = F.filter((M) => {
                if (E) {
                  const B = J(M.placement);
                  return B === w || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  B === "y";
                }
                return !0;
              }).map((M) => [M.placement, M.overflows.filter((B) => B > 0).reduce((B, Ht) => B + Ht, 0)]).sort((M, B) => M[1] - B[1])[0]) == null ? void 0 : tt[0];
              k && (N = k);
              break;
            }
            case "initialPlacement":
              N = l;
              break;
          }
        if (i !== N)
          return {
            reset: {
              placement: N
            }
          };
      }
      return {};
    }
  };
};
async function ue(t, e) {
  const {
    placement: n,
    platform: o,
    elements: i
  } = t, s = await (o.isRTL == null ? void 0 : o.isRTL(i.floating)), r = H(n), l = ot(n), a = J(n) === "y", c = ["left", "top"].includes(r) ? -1 : 1, f = s && a ? -1 : 1, d = nt(e, t);
  let {
    mainAxis: p,
    crossAxis: u,
    alignmentAxis: m
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...d
  };
  return l && typeof m == "number" && (u = l === "end" ? m * -1 : m), a ? {
    x: u * f,
    y: p * c
  } : {
    x: p * c,
    y: u * f
  };
}
const de = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var n, o;
      const {
        x: i,
        y: s,
        placement: r,
        middlewareData: l
      } = e, a = await ue(e, t);
      return r === ((n = l.offset) == null ? void 0 : n.placement) && (o = l.arrow) != null && o.alignmentOffset ? {} : {
        x: i + a.x,
        y: s + a.y,
        data: {
          ...a,
          placement: r
        }
      };
    }
  };
}, me = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: o,
        placement: i
      } = e, {
        mainAxis: s = !0,
        crossAxis: r = !1,
        limiter: l = {
          fn: (v) => {
            let {
              x: h,
              y: w
            } = v;
            return {
              x: h,
              y: w
            };
          }
        },
        ...a
      } = nt(t, e), c = {
        x: n,
        y: o
      }, f = await Vt(e, a), d = J(H(i)), p = _t(d);
      let u = c[p], m = c[d];
      if (s) {
        const v = p === "y" ? "top" : "left", h = p === "y" ? "bottom" : "right", w = u + f[v], y = u - f[h];
        u = pt(w, u, y);
      }
      if (r) {
        const v = d === "y" ? "top" : "left", h = d === "y" ? "bottom" : "right", w = m + f[v], y = m - f[h];
        m = pt(w, m, y);
      }
      const g = l.fn({
        ...e,
        [p]: u,
        [d]: m
      });
      return {
        ...g,
        data: {
          x: g.x - n,
          y: g.y - o
        }
      };
    }
  };
};
function X(t) {
  return yt(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function R(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function V(t) {
  var e;
  return (e = (yt(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function yt(t) {
  return t instanceof Node || t instanceof R(t).Node;
}
function L(t) {
  return t instanceof Element || t instanceof R(t).Element;
}
function _(t) {
  return t instanceof HTMLElement || t instanceof R(t).HTMLElement;
}
function Dt(t) {
  return typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof R(t).ShadowRoot;
}
function it(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: o,
    display: i
  } = D(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + o + n) && !["inline", "contents"].includes(i);
}
function pe(t) {
  return ["table", "td", "th"].includes(X(t));
}
function at(t) {
  return [":popover-open", ":modal"].some((e) => {
    try {
      return t.matches(e);
    } catch {
      return !1;
    }
  });
}
function xt(t) {
  const e = bt(), n = D(t);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !e && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !e && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((o) => (n.willChange || "").includes(o)) || ["paint", "layout", "strict", "content"].some((o) => (n.contain || "").includes(o));
}
function ge(t) {
  let e = W(t);
  for (; _(e) && !Q(e); ) {
    if (at(e))
      return null;
    if (xt(e))
      return e;
    e = W(e);
  }
  return null;
}
function bt() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Q(t) {
  return ["html", "body", "#document"].includes(X(t));
}
function D(t) {
  return R(t).getComputedStyle(t);
}
function ft(t) {
  return L(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function W(t) {
  if (X(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    Dt(t) && t.host || // Fallback.
    V(t)
  );
  return Dt(e) ? e.host : e;
}
function Ft(t) {
  const e = W(t);
  return Q(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : _(e) && it(e) ? e : Ft(e);
}
function et(t, e, n) {
  var o;
  e === void 0 && (e = []), n === void 0 && (n = !0);
  const i = Ft(t), s = i === ((o = t.ownerDocument) == null ? void 0 : o.body), r = R(i);
  return s ? e.concat(r, r.visualViewport || [], it(i) ? i : [], r.frameElement && n ? et(r.frameElement) : []) : e.concat(i, et(i, [], n));
}
function Mt(t) {
  const e = D(t);
  let n = parseFloat(e.width) || 0, o = parseFloat(e.height) || 0;
  const i = _(t), s = i ? t.offsetWidth : n, r = i ? t.offsetHeight : o, l = st(n) !== s || st(o) !== r;
  return l && (n = s, o = r), {
    width: n,
    height: o,
    $: l
  };
}
function Ot(t) {
  return L(t) ? t : t.contextElement;
}
function K(t) {
  const e = Ot(t);
  if (!_(e))
    return $(1);
  const n = e.getBoundingClientRect(), {
    width: o,
    height: i,
    $: s
  } = Mt(e);
  let r = (s ? st(n.width) : n.width) / o, l = (s ? st(n.height) : n.height) / i;
  return (!r || !Number.isFinite(r)) && (r = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: r,
    y: l
  };
}
const he = /* @__PURE__ */ $(0);
function Bt(t) {
  const e = R(t);
  return !bt() || !e.visualViewport ? he : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function ve(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== R(t) ? !1 : e;
}
function j(t, e, n, o) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const i = t.getBoundingClientRect(), s = Ot(t);
  let r = $(1);
  e && (o ? L(o) && (r = K(o)) : r = K(t));
  const l = ve(s, n, o) ? Bt(s) : $(0);
  let a = (i.left + l.x) / r.x, c = (i.top + l.y) / r.y, f = i.width / r.x, d = i.height / r.y;
  if (s) {
    const p = R(s), u = o && L(o) ? R(o) : o;
    let m = p, g = m.frameElement;
    for (; g && o && u !== m; ) {
      const v = K(g), h = g.getBoundingClientRect(), w = D(g), y = h.left + (g.clientLeft + parseFloat(w.paddingLeft)) * v.x, x = h.top + (g.clientTop + parseFloat(w.paddingTop)) * v.y;
      a *= v.x, c *= v.y, f *= v.x, d *= v.y, a += y, c += x, m = R(g), g = m.frameElement;
    }
  }
  return ct({
    width: f,
    height: d,
    x: a,
    y: c
  });
}
function we(t) {
  let {
    elements: e,
    rect: n,
    offsetParent: o,
    strategy: i
  } = t;
  const s = i === "fixed", r = V(o), l = e ? at(e.floating) : !1;
  if (o === r || l && s)
    return n;
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = $(1);
  const f = $(0), d = _(o);
  if ((d || !d && !s) && ((X(o) !== "body" || it(r)) && (a = ft(o)), _(o))) {
    const p = j(o);
    c = K(o), f.x = p.x + o.clientLeft, f.y = p.y + o.clientTop;
  }
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - a.scrollLeft * c.x + f.x,
    y: n.y * c.y - a.scrollTop * c.y + f.y
  };
}
function ye(t) {
  return Array.from(t.getClientRects());
}
function $t(t) {
  return j(V(t)).left + ft(t).scrollLeft;
}
function xe(t) {
  const e = V(t), n = ft(t), o = t.ownerDocument.body, i = z(e.scrollWidth, e.clientWidth, o.scrollWidth, o.clientWidth), s = z(e.scrollHeight, e.clientHeight, o.scrollHeight, o.clientHeight);
  let r = -n.scrollLeft + $t(t);
  const l = -n.scrollTop;
  return D(o).direction === "rtl" && (r += z(e.clientWidth, o.clientWidth) - i), {
    width: i,
    height: s,
    x: r,
    y: l
  };
}
function be(t, e) {
  const n = R(t), o = V(t), i = n.visualViewport;
  let s = o.clientWidth, r = o.clientHeight, l = 0, a = 0;
  if (i) {
    s = i.width, r = i.height;
    const c = bt();
    (!c || c && e === "fixed") && (l = i.offsetLeft, a = i.offsetTop);
  }
  return {
    width: s,
    height: r,
    x: l,
    y: a
  };
}
function Oe(t, e) {
  const n = j(t, !0, e === "fixed"), o = n.top + t.clientTop, i = n.left + t.clientLeft, s = _(t) ? K(t) : $(1), r = t.clientWidth * s.x, l = t.clientHeight * s.y, a = i * s.x, c = o * s.y;
  return {
    width: r,
    height: l,
    x: a,
    y: c
  };
}
function kt(t, e, n) {
  let o;
  if (e === "viewport")
    o = be(t, n);
  else if (e === "document")
    o = xe(V(t));
  else if (L(e))
    o = Oe(e, n);
  else {
    const i = Bt(t);
    o = {
      ...e,
      x: e.x - i.x,
      y: e.y - i.y
    };
  }
  return ct(o);
}
function Wt(t, e) {
  const n = W(t);
  return n === e || !L(n) || Q(n) ? !1 : D(n).position === "fixed" || Wt(n, e);
}
function Ee(t, e) {
  const n = e.get(t);
  if (n)
    return n;
  let o = et(t, [], !1).filter((l) => L(l) && X(l) !== "body"), i = null;
  const s = D(t).position === "fixed";
  let r = s ? W(t) : t;
  for (; L(r) && !Q(r); ) {
    const l = D(r), a = xt(r);
    !a && l.position === "fixed" && (i = null), (s ? !a && !i : !a && l.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || it(r) && !a && Wt(t, r)) ? o = o.filter((f) => f !== r) : i = l, r = W(r);
  }
  return e.set(t, o), o;
}
function Ce(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: o,
    strategy: i
  } = t;
  const r = [...n === "clippingAncestors" ? at(e) ? [] : Ee(e, this._c) : [].concat(n), o], l = r[0], a = r.reduce((c, f) => {
    const d = kt(e, f, i);
    return c.top = z(d.top, c.top), c.right = G(d.right, c.right), c.bottom = G(d.bottom, c.bottom), c.left = z(d.left, c.left), c;
  }, kt(e, l, i));
  return {
    width: a.right - a.left,
    height: a.bottom - a.top,
    x: a.left,
    y: a.top
  };
}
function Ae(t) {
  const {
    width: e,
    height: n
  } = Mt(t);
  return {
    width: e,
    height: n
  };
}
function Re(t, e, n) {
  const o = _(e), i = V(e), s = n === "fixed", r = j(t, !0, s, e);
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const a = $(0);
  if (o || !o && !s)
    if ((X(e) !== "body" || it(i)) && (l = ft(e)), o) {
      const d = j(e, !0, s, e);
      a.x = d.x + e.clientLeft, a.y = d.y + e.clientTop;
    } else
      i && (a.x = $t(i));
  const c = r.left + l.scrollLeft - a.x, f = r.top + l.scrollTop - a.y;
  return {
    x: c,
    y: f,
    width: r.width,
    height: r.height
  };
}
function dt(t) {
  return D(t).position === "static";
}
function Pt(t, e) {
  return !_(t) || D(t).position === "fixed" ? null : e ? e(t) : t.offsetParent;
}
function It(t, e) {
  const n = R(t);
  if (at(t))
    return n;
  if (!_(t)) {
    let i = W(t);
    for (; i && !Q(i); ) {
      if (L(i) && !dt(i))
        return i;
      i = W(i);
    }
    return n;
  }
  let o = Pt(t, e);
  for (; o && pe(o) && dt(o); )
    o = Pt(o, e);
  return o && Q(o) && dt(o) && !xt(o) ? n : o || ge(t) || n;
}
const Se = async function(t) {
  const e = this.getOffsetParent || It, n = this.getDimensions, o = await n(t.floating);
  return {
    reference: Re(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function Te(t) {
  return D(t).direction === "rtl";
}
const De = {
  convertOffsetParentRelativeRectToViewportRelativeRect: we,
  getDocumentElement: V,
  getClippingRect: Ce,
  getOffsetParent: It,
  getElementRects: Se,
  getClientRects: ye,
  getDimensions: Ae,
  getScale: K,
  isElement: L,
  isRTL: Te
};
function ke(t, e) {
  let n = null, o;
  const i = V(t);
  function s() {
    var l;
    clearTimeout(o), (l = n) == null || l.disconnect(), n = null;
  }
  function r(l, a) {
    l === void 0 && (l = !1), a === void 0 && (a = 1), s();
    const {
      left: c,
      top: f,
      width: d,
      height: p
    } = t.getBoundingClientRect();
    if (l || e(), !d || !p)
      return;
    const u = rt(f), m = rt(i.clientWidth - (c + d)), g = rt(i.clientHeight - (f + p)), v = rt(c), w = {
      rootMargin: -u + "px " + -m + "px " + -g + "px " + -v + "px",
      threshold: z(0, G(1, a)) || 1
    };
    let y = !0;
    function x(b) {
      const E = b[0].intersectionRatio;
      if (E !== a) {
        if (!y)
          return r();
        E ? r(!1, E) : o = setTimeout(() => {
          r(!1, 1e-7);
        }, 1e3);
      }
      y = !1;
    }
    try {
      n = new IntersectionObserver(x, {
        ...w,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(x, w);
    }
    n.observe(t);
  }
  return r(!0), s;
}
function Pe(t, e, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: s = !0,
    elementResize: r = typeof ResizeObserver == "function",
    layoutShift: l = typeof IntersectionObserver == "function",
    animationFrame: a = !1
  } = o, c = Ot(t), f = i || s ? [...c ? et(c) : [], ...et(e)] : [];
  f.forEach((h) => {
    i && h.addEventListener("scroll", n, {
      passive: !0
    }), s && h.addEventListener("resize", n);
  });
  const d = c && l ? ke(c, n) : null;
  let p = -1, u = null;
  r && (u = new ResizeObserver((h) => {
    let [w] = h;
    w && w.target === c && u && (u.unobserve(e), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var y;
      (y = u) == null || y.observe(e);
    })), n();
  }), c && !a && u.observe(c), u.observe(e));
  let m, g = a ? j(t) : null;
  a && v();
  function v() {
    const h = j(t);
    g && (h.x !== g.x || h.y !== g.y || h.width !== g.width || h.height !== g.height) && n(), g = h, m = requestAnimationFrame(v);
  }
  return n(), () => {
    var h;
    f.forEach((w) => {
      i && w.removeEventListener("scroll", n), s && w.removeEventListener("resize", n);
    }), d == null || d(), (h = u) == null || h.disconnect(), u = null, a && cancelAnimationFrame(m);
  };
}
const Le = de, _e = me, Ne = fe, Ve = ae, Fe = (t, e, n) => {
  const o = /* @__PURE__ */ new Map(), i = {
    platform: De,
    ...n
  }, s = {
    ...i.platform,
    _c: o
  };
  return ce(t, e, {
    ...i,
    platform: s
  });
};
function Me(t) {
  return t != null && typeof t == "object" && "$el" in t;
}
function ht(t) {
  if (Me(t)) {
    const e = t.$el;
    return yt(e) && X(e) === "#comment" ? null : e;
  }
  return t;
}
function U(t) {
  return typeof t == "function" ? t() : mt(t);
}
function Be(t) {
  return {
    name: "arrow",
    options: t,
    fn(e) {
      const n = ht(U(t.element));
      return n == null ? {} : Ve({
        element: n,
        padding: t.padding
      }).fn(e);
    }
  };
}
function zt(t) {
  return typeof window > "u" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Lt(t, e) {
  const n = zt(t);
  return Math.round(e * n) / n;
}
function $e(t, e, n) {
  n === void 0 && (n = {});
  const o = n.whileElementsMounted, i = T(() => {
    var O;
    return (O = U(n.open)) != null ? O : !0;
  }), s = T(() => U(n.middleware)), r = T(() => {
    var O;
    return (O = U(n.placement)) != null ? O : "bottom";
  }), l = T(() => {
    var O;
    return (O = U(n.strategy)) != null ? O : "absolute";
  }), a = T(() => {
    var O;
    return (O = U(n.transform)) != null ? O : !0;
  }), c = T(() => ht(t.value)), f = T(() => ht(e.value)), d = P(0), p = P(0), u = P(l.value), m = P(r.value), g = jt({}), v = P(!1), h = T(() => {
    const O = {
      position: u.value,
      left: "0",
      top: "0"
    };
    if (!f.value)
      return O;
    const S = Lt(f.value, d.value), A = Lt(f.value, p.value);
    return a.value ? {
      ...O,
      transform: "translate(" + S + "px, " + A + "px)",
      ...zt(f.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: u.value,
      left: S + "px",
      top: A + "px"
    };
  });
  let w;
  function y() {
    c.value == null || f.value == null || Fe(c.value, f.value, {
      middleware: s.value,
      placement: r.value,
      strategy: l.value
    }).then((O) => {
      d.value = O.x, p.value = O.y, u.value = O.strategy, m.value = O.placement, g.value = O.middlewareData, v.value = !0;
    });
  }
  function x() {
    typeof w == "function" && (w(), w = void 0);
  }
  function b() {
    if (x(), o === void 0) {
      y();
      return;
    }
    if (c.value != null && f.value != null) {
      w = o(c.value, f.value, y);
      return;
    }
  }
  function E() {
    i.value || (v.value = !1);
  }
  return ut([s, r, l], y, {
    flush: "sync"
  }), ut([c, f], b, {
    flush: "sync"
  }), ut(i, E, {
    flush: "sync"
  }), Xt() && Yt(x), {
    x: q(d),
    y: q(p),
    strategy: q(u),
    placement: q(m),
    middlewareData: q(g),
    isPositioned: q(v),
    floatingStyles: h,
    update: y
  };
}
const We = {
  mounted: function(t, e) {
    t.clickOutsideEvent = function(n) {
      const o = document.getElementById(e.arg);
      !(t == n.target || t.contains(n.target)) && !(o && (n.target == o || o.contains(n.target))) && e.value(n, t);
    }, document.addEventListener("click", t.clickOutsideEvent);
  },
  unmounted: function(t) {
    document.removeEventListener("click", t.clickOutsideEvent);
  }
}, Ie = {
  mounted: function(t, e) {
    t.clickOutsideEvent = function(n) {
      const o = document.getElementById(e.arg);
      !(t == n.target || t.contains(n.target)) && !(o && (n.target == o || o.contains(n.target))) && e.value(n, t);
    }, document.addEventListener("touchstart", t.clickOutsideEvent);
  },
  unmounted: function(t) {
    document.removeEventListener("touchstart", t.clickOutsideEvent);
  }
}, ze = ["data-popper-placement"], He = /* @__PURE__ */ qt({
  __name: "FrPopover",
  props: {
    placement: { type: String, default: "bottom" },
    trigger: { type: String, default: "click" },
    popoverWidth: { type: Number },
    openDelay: { type: Number, default: 0 },
    closeDelay: { type: Number, default: 0 },
    tabindex: { type: Number, default: 700 },
    popperClass: { type: String, default: "" },
    offset: { type: Number, default: 0 },
    forceOpen: { type: Boolean, default: !1 },
    arrowSettings: Object
  },
  emits: ["opened", "closed"],
  setup(t, { expose: e, emit: n }) {
    const o = t, i = P(!1), s = P(null), r = P(null), l = P(null), a = P([Le(7 + (o.offset || 0)), Ne(), _e(), Be({ element: l })]), { floatingStyles: c, middlewareData: f } = $e(s, r, {
      placement: o.placement,
      middleware: a,
      whileElementsMounted: Pe
    }), d = {
      top: "bottom",
      right: "left",
      bottom: "top",
      left: "right",
      "top-start": "bottom",
      "top-end": "bottom",
      "right-start": "left",
      "right-end": "left",
      "bottom-start": "top",
      "bottom-end": "top",
      "left-start": "right",
      "left-end": "right"
    }, p = T(() => {
      var b;
      const x = (b = c.value.transform) == null ? void 0 : b.match(/(-?\d+(?:\.\d+)?)px, (-?\d+(?:\.\d+)?)px/);
      return x && (c.value.transform = `translate(${Number(x[1])}px, ${Number(x[2])}px)`), { ...c.value, width: o.popoverWidth + "px", zIndex: o.tabindex };
    }), u = T(() => {
      var x, b;
      return ((b = (x = f.value) == null ? void 0 : x.offset) == null ? void 0 : b.placement) || o.placement;
    }), m = T(() => {
      var x, b, E, O, S, A;
      return {
        left: ((x = f.value.arrow) == null ? void 0 : x.x) != null ? (((b = o.arrowSettings) == null ? void 0 : b.x) || f.value.arrow.x) + "px" : "",
        top: ((E = f.value.arrow) == null ? void 0 : E.y) != null ? (((O = o.arrowSettings) == null ? void 0 : O.y) || f.value.arrow.y) + "px" : "",
        [d[(S = f.value.offset) == null ? void 0 : S.placement]]: `${-(((A = l.value) == null ? void 0 : A.offsetWidth) || 10) / 2 - 1}px`
      };
    });
    function g() {
      o.trigger === "click" && (i.value ? y() : w());
    }
    function v() {
      o.trigger === "hover" && w();
    }
    function h() {
      o.trigger === "hover" && y();
    }
    function w() {
      setTimeout(() => {
        i.value = !0, n("opened");
      }, o.openDelay);
    }
    function y() {
      setTimeout(() => {
        i.value = !1, n("closed");
      }, o.closeDelay);
    }
    return e({
      hide: y
    }), (x, b) => Ut((Et(), Ct("div", null, [
      At("div", {
        class: "frisbuy-popover",
        ref_key: "reference",
        ref: s,
        onMouseenter: v,
        onMouseleave: h,
        onClick: g
      }, [
        Rt(x.$slots, "reference", {}, void 0, !0)
      ], 544),
      Kt(Gt, { name: "popover-fade" }, {
        default: Jt(() => [
          i.value || t.forceOpen ? (Et(), Ct("div", {
            key: 0,
            class: Qt(["frisbuy-popover__tooltip", t.popperClass]),
            ref_key: "floating",
            ref: r,
            style: St(p.value)
          }, [
            Rt(x.$slots, "default", {}, void 0, !0),
            At("div", {
              class: "frisbuy-popover__arrow",
              ref_key: "floatingArrow",
              ref: l,
              style: St(m.value),
              "data-popper-placement": u.value
            }, null, 12, ze)
          ], 6)) : Zt("", !0)
        ]),
        _: 3
      })
    ])), [
      [mt(We), y],
      [mt(Ie), y]
    ]);
  }
});
const Ye = /* @__PURE__ */ te(He, [["__scopeId", "data-v-a9a8218f"]]);
export {
  Ye as default
};
